<template>
<div class="product_introduction">
  <div class="introduction_title">
    <span class="text">产品介绍</span>
  </div>
  <div class="introduction_content">
    <div
      class="tab_items"
      v-for="item in tabList"
      :key="item.key"
      @click.stop="menuChange(item.key)"
      :class="{ tab_active: item.key === severTabKey }"
    >{{item.tabName}}
    </div>
  </div>
  <div class="introduction_skip_content">
    <transition name="moveCartoon" appear>
      <div style="height: 700PX" v-show="severTabKey === '1'">
          <div class="content_text"><span class="gradual">企业级智慧税务综合管理平台</span></div>
          <div class="content_tips">为企业提供一站式智能税务管理和全税种自动计税一键申报服务</div>
          <div class="content_img"><hm-img type="images" imgName="home_product_02_zh" imgClass="introduction_img_style" /></div>
          <div class="content_btn">
            <a-button @click.stop="toNewPage" style="margin-right: 16PX;" type="left">产品详情</a-button>
              <a-button @click.stop="gotoTryout" type="right">申请试用</a-button>
          </div>
      </div>
    </transition>
    <transition name="moveCartoon" appear>
      <div style="height: 600PX" v-show="severTabKey === '2'">
        <div class="content_img_2">
              <hm-img type="images" imgName="home_product_03_zh" imgClass="introduction_img_style" />
              <div @click.stop="toNewPage" class="content_img_skip"><span class="tips">产品详情</span>
                  <div class="introduction_icon_style"><hm-img type="images" imgName="home_icon_03_zh" imgClass="introduction_img_style" /></div>
              </div>
        </div>
      </div>
    </transition>
      <transition name="moveCartoon" appear>
        <div style="height: 700PX" v-show="severTabKey === '3'">
            <div class="content_text_3">专为初创及小微企业打造的记账报税一站式SaaS平台</div>
            <div class="content_tips_3"><a-button @click.stop="toNewPage" type="left">产品详情</a-button></div>
            <div class="content_img_3"><hm-img type="images" imgName="home_product_04_zh" imgClass="introduction_img_style" /></div>
        </div>
      </transition>
      <transition name="moveCartoon" appear>
        <div style="height: 700PX" v-show="severTabKey === '4'">
            <div class="content_text_4">全面归集并实时更新最新政策法规和热点问题</div>
              <div class="content_tips_4"><a-button @click.stop="toNewPage" type="left">产品详情</a-button></div>
              <div class="content_img_4">
                <hm-img type="images" imgName="home_product_05_zh" imgClass="introduction_img_style" />
              </div>
        </div>
      </transition>
      <transition name="moveCartoon" appear>
        <div style="height: 700PX" v-show="severTabKey === '5'">
            <div class="content_text_4">助力企业提高税务合规遵从度及信用评级</div>
              <div class="content_tips_4"><a-button @click.stop="toNewPage" type="left">产品详情</a-button></div>
              <div class="content_img_5"><hm-img type="images" imgName="home_product_06_zh" imgClass="introduction_img_style" />
            </div>
        </div>
      </transition>
  </div>
</div>
</template>

<script>
const tabList = [
  {
    key: '1',
    tabName: '税纪云'
  },
  {
    key: '2',
    tabName: 'Taxcellent'
  },
  // {
  //   key: '3',
  //   tabName: '财纪云 Fincellent'
  // },
  {
    key: '4',
    tabName: '法规库'
  },
  {
    key: '5',
    tabName: '行业数据库'
  }
]
export default {
  name: '',
  props: {},
  components: {},
  data () {
    return {
      tabList,
      severTabKey: '1'
    }
  },
  filters: {},
  watch: {

  },
  computed: {

  },
  created () {

  },
  methods: {
    menuChange (val) {
      console.log('%cval', 'background-color: pink;', val)
      // this.loading = true
      // setTimeout(() => {
      this.severTabKey = val
      //   this.loading = false
      // }, 1000)
    },
    toNewPage () {
      console.log('%ctoNewPage', 'background-color: pink;', this.severTabKey)
      let target = {}
      switch (this.severTabKey) {
        case '1':
          target = {name: 'product', params: {type: 'newTaxera'}}
          break
        case '2':
          target = {name: 'product', params: {type: 'taxcellent'}}
          break
        case '3':
          target = {name: 'product', params: {type: 'fincellent'}}
          break
        case '4':
          target = {name: 'product', params: {type: 'lawLibrary'}}
          break
        case '5':
          target = {name: 'product', params: {type: 'ibd'}}
          break
        default:
          break
      }
      this.$router.push(target)
    },
    gotoTryout () {
      this.$router.push({ name: 'tryOut' })
    }
  }
}
</script>

<style scoped lang='less'>
#hm-web {
.moveCartoon-enter-active {
    animation: move .5s;
}
.moveCartoon-leave-active {
    // animation: move 0s reverse;
}
@keyframes move {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.5;
    }
    100% {
      opacity: 1;
    }
}
.product_introduction {
  width: 100%;
  min-height: 941PX;
  background-color: #F7F9FB;
  .introduction_title {
    padding-top: 80PX;
    margin-bottom: 48PX;
    text-align: center;
    // background-color: #F7F9FB;
    .text {
      font-size: 36PX;
      color: #292F3A;
      font-weight: 500;
    }
  }
  .introduction_content {
    width: 1200PX;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    .tab_items {
      width: 214PX;
      height: 56PX;
      margin: 0 16PX;
      border: none;
      border-bottom: 1PX solid #ccc;
      // transform: scaleY(-1);
      font-size: 18PX;
      line-height: 56PX;
      color: #292F3A;
      text-align: center;
      font-weight: 600;
      cursor: pointer;
      &:hover {
      border-bottom: 2PX solid #3e77ff;
      background-image: linear-gradient(180deg, rgba(255,255,255,0.00), #FFFFFF);
    }
    }
    .tab_active {
      color: #3E77FF;
      border-bottom: 2PX solid #3e77ff;
      background-image: linear-gradient(180deg, rgba(255,255,255,0.00), #FFFFFF);
    }
  }
.introduction_skip_content {
    width: 1200PX;
    height: 750PX;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    .content_text {
      margin: 77PX 0 24PX;
      .gradual {
        font-size: 36PX;
        font-weight: 500;
        background: linear-gradient(to right, #3E77FF, #25C9B0, #25C9B0);
        -webkit-background-clip: text;
        color: transparent;
      }
    }
    .content_tips {
      font-size: 20PX;
      color: #292F3A;
      font-weight: 500;
      // transform: translateY(100%);
    }
    .content_img {
      height: 484PX;
      width: 1129PX;
      margin: 0 auto;
      transform: translateY(-3%);
    }
    .content_img_2 {
      width: 1129PX;
      height: 620PX;
      margin: 0 auto;
      margin-top: 140PX;
      position: relative;
      .content_img_skip {
        font-size: 16PX;
        color: #3E77FF;
        font-weight: 600;
        position: absolute;
        bottom: 20%;
        right: 15%;
        cursor: pointer;
        display: flex;
        align-items: center;
        transition: all .3s ease;
        .tips {
          margin-right: 9PX;
        }
        .introduction_icon_style {
          width: 18PX;
          height: 10PX;
          line-height: 10PX;
          opacity: 0;
          width: 0PX;
          transition: width .5s ease;
        }
        &:hover {
          .introduction_icon_style {
            width: 18PX;
            height: 10PX;
            line-height: 10PX;
            opacity: 1;
            transition: width .5s ease;
          }
        }
      }
    }
    .content_text_3 {
      margin: 80PX 0 40PX;
      font-size: 32PX;
      color: #292F3A;
      text-align: center;
      line-height: 36PX;
      font-weight: 500;
    }
    .content_tips_3 {
      margin-bottom: 44PX;
    }
    .content_img_3 {
      height: 414PX;
      width: 1192PX;
      margin: 0 auto;
    }
    .content_text_4 {
      margin-top: 80PX;
      font-size: 32PX;
      color: #292F3A;
      text-align: center;
      line-height: 36PX;
      font-weight: 500;
    }
    .content_img_4 {
      height: 692PX;
      width: 1000PX;
      margin: 0 auto;
      position: relative;
    }
    .content_img_5 {
      height: 692PX;
      width: 929PX;
      margin: 0 auto;
      position: relative;
    }
    .content_tips_4 {
      margin-top: 40PX;
      // margin-bottom: 44PX;
      // position: absolute;
      // top: 5%;
      // left: 50%;
      // transform: translateX(-50%);
    }
    .content_btn {
      transform: translateY(-100%);
    }
  }
  /deep/.ant-btn-left {
    background-color: #FFFFFF;
    color: #607296;;
    border-color: transparent;
    border: 1PX solid #ccc;
  }
  /deep/.ant-btn-right {
    background: linear-gradient(90deg, #3E77FF, #3BA7FC, #68A4F2);
    color: #FFFFFF;
    border-color: transparent;
    border: 1PX solid rgba(216,221,230,1);
  }
  /deep/.ant-btn:focus {
      border-color: transparent;
      border: 1PX solid rgba(216,221,230,);
    }
  /deep/.ant-btn:hover {
    border-color: transparent;
    border: 1PX solid rgba(216,221,230,1);
    box-shadow: 0PX 6PX 8PX 0PX rgba(126,145,193,0.2);
  }
  /deep/.ant-btn {
    width: 148PX;
    height: 48PX;
    border-radius: 7PX;
    // box-shadow: 0PX 3PX 4PX 0PX rgba(126,145,193,0.35);
    span {
      font-size: 16PX;
      font-weight: 600;
    }
  }
}
}
</style>
<style lang="less">
  #hm-web {
    .introduction_img_style {
      width: 100%;
      height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home/components/productIntroduction.vue